<template>
  <v-row>
    <!-- kitchen sink -->
    <v-col cols="12">
      <app-card-code
        :title="`${$t('menu.nomenclador')} / ${$t('menu.cars')} / ${$t('menu.ptoRecogida')}`"
      >
        <PtoRecogida></PtoRecogida>
      </app-card-code>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

import PtoRecogida from './tablas/PtoRecogida.vue'

export default {
  components: {
    AppCardCode,
    PtoRecogida,
  },
}
</script>
